import { createFileRoute } from '@tanstack/react-router';
import { DiagnosticsDashboard } from '@amber-ui/core';

function DevicesIndex() {
  return <DiagnosticsDashboard basePath="/devices" />;
}

export const Route = createFileRoute('/devices/')({
  component: DevicesIndex,
});
